var Ips = {
  ip1: "https://fixtest.allscs.cn/jhh" //测试
  // ip1: "https://fix.allscs.cn/jhh"
  //ip1: "http://localhost:8089" //本地
};
module.exports = { Ips };



// WEBPACK FOOTER //
// ./src/config/ip.js